import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {calculateMerchantsAnalytics} from '../../../functionts/calculateMerchantsAnalytics';
import {formatCurrency} from '../../../functionts/formatCurrency';
import {pluralize} from '../../../functionts/pluralize';
import {IMerchant} from '../../../interfaces/payment/IMerchant';
import {IAnalyticsData} from './type/IAnalyticsData';

interface IMerchantsAnalytics {
    merchants: IMerchant[];
}

const MerchantsAnalytics = React.forwardRef<HTMLDivElement, IMerchantsAnalytics>(({merchants}, ref) => {
    const analyticsData: IAnalyticsData = React.useMemo(() => calculateMerchantsAnalytics(merchants), [merchants]);

    return (
        <Box
            ref={ref}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                mb: 2,
                p: 2,
                bgcolor: 'background.paper',
                borderRadius: 1,
                boxShadow: 1,
            }}
        >
            <Box>
                <Typography variant="caption" color="textSecondary">
                    Подключено:
                </Typography>
                <Typography variant="body2" component="span" sx={{ml: 1}}>
                    {pluralize(analyticsData.totalMerchants, 'мерчант', 'мерчанта', 'мерчантов')} • {pluralize(analyticsData.totalKKMs, 'касса', 'кассы', 'касс')}
                </Typography>
            </Box>
            <Box>
                <Typography variant="caption" color="textSecondary">
                    К оплате на следующий месяц:
                </Typography>
                <Typography variant="h6" component="span" sx={{ml: 1, fontWeight: 'bold'}}>
                    {formatCurrency(analyticsData.totalPaymentDue)} ₸
                </Typography>
            </Box>
        </Box>
    );
});

export default MerchantsAnalytics;
